// extracted by mini-css-extract-plugin
export default {"frame":"Responsive_frame__AnPVc"};